import React from 'react';
import { Link } from 'react-scroll';
import Logo from '../elements/Logo';

function Header({
  light,
  logoSource,
  toggleMenu,
  headerToggler,
  setToggleMenu,
}) {
  const handleClasses = () => {
    let classes = 'desktop-header-1 d-flex align-items-start flex-column';
    if (light & toggleMenu) {
      classes += ' light open';
    } else if (toggleMenu) {
      classes += ' open';
    } else if (light) {
      classes += ' light';
    }
    return classes;
  };
  const handleMobileClasses = () => {
    let classes = 'mobile-header-1';
    if (light & toggleMenu) {
      classes += ' light open';
    } else if (toggleMenu) {
      classes += ' open';
    } else if (light) {
      classes += ' light';
    }
    return classes;
  };

  return (
    <>
      <header className={handleMobileClasses()}>
        <div className="container">
          <div className="menu-icon d-inline-flex mr-4">
            <button onClick={headerToggler}>
              <span></span>
            </button>
          </div>
          <Logo logoSource={logoSource} />
        </div>
      </header>
      <header className={handleClasses()}>
        <Logo logoSource={logoSource} />
        <nav>
          <ul className="vertical-menu scrollspy">
            <li>
              <Link
                activeClass="active"
                to="section-home"
                spy={true}
                smooth={true}
                duration={500}
                onClick={() => setToggleMenu(false)}
              >
                <i className="icon-home"></i>Home
              </Link>
            </li>
            <li>
              <Link
                activeClass="active"
                to="section-about"
                spy={true}
                smooth={true}
                duration={500}
                onClick={() => setToggleMenu(false)}
              >
                <i className="icon-user-following"></i>About
              </Link>
            </li>
            <li>
              <Link
                activeClass="active"
                to="section-skills"
                spy={true}
                smooth={true}
                duration={500}
                onClick={() => setToggleMenu(false)}
              >
                <i className="icon-magic-wand"></i>Skills
              </Link>
            </li>
            <li>
              <Link
                activeClass="active"
                to="section-projects"
                spy={true}
                smooth={true}
                duration={500}
                onClick={() => setToggleMenu(false)}
              >
                <i className="icon-layers"></i>Projects
              </Link>
            </li>
            <li>
              <Link
                activeClass="active"
                to="section-contact"
                spy={true}
                smooth={true}
                duration={500}
                onClick={() => setToggleMenu(false)}
              >
                <i className="icon-bubbles"></i>Contact
              </Link>
            </li>
          </ul>
        </nav>

        <div className="footer">
          <span className="copyright">
            <span> "nani, gigantum humeris insidentes"</span>
            <br />
            &copy; {new Date().getFullYear()} Pablo Alvarez Imaz.
          </span>
        </div>
      </header>
    </>
  );
}

export default Header;
